import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropdownModule } from '../dropdown/dropdown.module';
import { IconModule } from '../icon/icon.module';

import { SelectedItemsComponent } from './selected-items/selected-items.component';
import { ListActionsComponent } from './list-actions/list-actions.component';


@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    IconModule,
  ],
  declarations: [
    SelectedItemsComponent,
    ListActionsComponent,
  ],
  exports: [
    SelectedItemsComponent,
    ListActionsComponent,
  ]
})
export class ContextualActionsModule {}
